var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg31(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 7.90056C13.475 7.72556 13.15 7.82556 12.975 8.07556L10.325 12.2756C10.275 12.3256 10.225 12.4006 10.2 12.4756C10.15 12.5506 10.125 12.6256 10.125 12.7006L9.25 15.0006L11 13.2256C11.05 13.1756 11.1 13.1256 11.15 13.0756C11.2 13.0256 11.25 12.9506 11.275 12.8756L13.925 8.67556C14.075 8.40056 14 8.05056 13.75 7.90056Z",
    fill: "#0092CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9 12.7002C7.1 12.9002 6.275 13.0252 5.5 13.0252C3.675 13.0252 1.95 12.3502 1.125 11.9752C1.225 10.6002 1.675 9.3502 2.45 8.4252C3.25 7.4752 4.35 6.9502 5.5 6.9502C6.65 6.9502 7.75 7.4752 8.55 8.4252C8.975 8.9252 9.3 9.5252 9.525 10.2002C9.625 10.5002 9.95 10.6502 10.225 10.5502C10.525 10.4502 10.675 10.1252 10.575 9.8502C10.3 9.0252 9.9 8.3002 9.4 7.7002C8.75 6.9252 7.925 6.3752 7.025 6.0752C7.925 5.5502 8.525 4.5752 8.525 3.4752C8.525 1.8002 7.175 0.450195 5.5 0.450195C3.825 0.450195 2.475 1.8002 2.475 3.4752C2.475 4.5752 3.075 5.5502 3.975 6.0752C3.075 6.3752 2.275 6.9252 1.6 7.7002C0.6 8.8752 0.05 10.5252 0 12.3002C0 12.5252 0.125 12.7252 0.3 12.8252C0.925 13.1252 3.125 14.1502 5.5 14.1502C6.375 14.1502 7.275 14.0252 8.175 13.8002C8.475 13.7252 8.65 13.4252 8.575 13.1252C8.5 12.8002 8.2 12.6252 7.9 12.7002ZM5.5 1.5752C6.55 1.5752 7.4 2.4252 7.4 3.4752C7.4 4.5252 6.55 5.3752 5.5 5.3752C4.45 5.3752 3.6 4.5252 3.6 3.4752C3.6 2.4252 4.45 1.5752 5.5 1.5752Z",
    fill: "#0092CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg31);
export default __webpack_public_path__ + "static/media/svg31.df0f13fccd82fbbe1aa3a4d47b88297e.svg";
export { ForwardRef as ReactComponent };